export default {
subtitle: "",
path: "webhooks_subect_approved",
paragraph: "This webhook notifies when a person or company registration has been approved:",
request: {
    method: "POST",
	payloads: [
		 {
			title: "Notification",
			content: { 
			"notification": {
				"type": "subject_approved",
				"subject_id": "UUID",
				"secret": "the value you received"
				}
			 }
		  }
		]
	}
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/WebHook/WebhooksSubjectApproved.js